<template>
  <v-container id="liga-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-calendar-account" inline class="px-5 py-3" title="Consultas profesionales">
      <template v-if="$can('M_consultas_gestion')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewConsulta('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-calendar-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="consultas"
        :search.sync="search"
        multi-sort
      >
        <template v-if="$can('M_consultas_gestion')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToNewConsulta('edit', item.id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        search: undefined,
        headers: [
          { text: 'Turno', sortable: true, value: 'fecha_hora_asignado' },
          { text: 'Jugador', sortable: true, value: 'jugador' },
          { text: 'Profesional', sortable: true, value: 'medico' },
          { text: 'Especialidad', sortable: true, value: 'especialidad' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        consultas: [],
        jugador: {
          fullName: '',
        },
        editedIndex: -1,
        dataForm: {

        },
      }
    },

    created () {
      this.getConsultas()
    },

    methods: {

      getConsultas: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/consulta_medica_turno' }).then(response => { this.consultas = response })
      },

      goToNewConsulta: function (modeVal, consultaId) {
        this.$router.push({ name: 'Alta consulta profesional', params: { id: consultaId, mode: modeVal } })
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', '¿Está seguro de eliminar turno?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/consulta_medica_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Consulta eliminada'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getConsultas()
      },
    },
  }
</script>
